import React from "react";
import { useTranslation } from 'react-i18next';

function Services() {
  const { t } = useTranslation('homepage');

  return (
    <section className="tc-services-style1">
      <div className="content section-padding section-padding-x">
        <div className="container">
          <div className="title mb-80 text-center">
            <p className="color-666 text-uppercase wow">{t('services.sectionTitle')}</p>
            <h2 className="fsz-40 fw-600 mt-10">{t('services.sectionSubtitle')}</h2>
          </div>
          <div className="services">
            <div className="row">
              <div className="col-lg-3">
                <a
                  href="/innerpages/portfolio"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="icon">
                    <i className="la la-tree"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">{t('services.items.0.title')}</h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/slider/1.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    {t('services.items.0.description')}
                  </div>
                  
                </a>
              </div>

              <div className="col-lg-3">
                <a
                  href="/innerpages/portfolio"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="icon">
                    <i className="la la-water"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">{t('services.items.1.title')}</h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/slider/4.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    {t('services.items.1.description')}
                  </div>
                 
                </a>
              </div>

              <div className="col-lg-3">
                <a
                  href="/innerpages/portfolio"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <div className="icon">
                    <i className="la la-home"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">{t('services.items.2.title')}</h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser5.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    {t('services.items.2.description')}
                  </div>
                 
                </a>
              </div>

              <div className="col-lg-3">
                <a
                  href="/innerpages/portfolio"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <div className="icon">
                    <i className="la la-map-marker"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">{t('services.items.3.title')}</h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser6.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    {t('services.items.3.description')}
                  </div>
                  
                </a>
              </div>
            </div>
          </div>

          <div className="text-center">
            <a
              href="/innerpages/portfolio"
              className="butn border rounded-pill mt-60 hover-bg-white"
            >
              <span>
                {t('services.viewApartmentsButton')}
                <i className="small ms-1 ti-arrow-top-right"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div className="ser-img mt-5">
        <img src="/home1/assets/img/services/ser.png" alt="" />
      </div>
    </section>
  );
}

export default Services;
